import {
  IUISceneController,
  TTranslateEditSceneParams,
  TTranslateEditSceneResult,
} from "./types";
import { ScenesInstance } from "@scenes/PrototypeScene";
import { Utils } from "@modules/utils";
import { TSceneDisplayOptions } from "@viewModels/scenes/__types__/SceneDisplay";
import { ITranslateViewModel } from "@viewModels/TranslateViewModel/__types__/ITranslateViewModel";
import { TranslateViewModel } from "@viewModels/TranslateViewModel/TranslateViewModel";
import { ITranslateEntity, TranslateEntity } from "@entities/TranslateEntity";
import { message } from "antd";

export class UISceneController<
    T extends TTranslateEditSceneResult,
    P extends TTranslateEditSceneParams
  >
  extends ScenesInstance<T, P>
  implements IUISceneController<T, P>
{
  public static _name: string = "TranslateEditScene";

  private TranslateViewModel: ITranslateViewModel;

  public constructor(
    options: TSceneDisplayOptions,
    private params: TTranslateEditSceneParams
  ) {
    super(options);

    this.TranslateViewModel = new TranslateViewModel(this.params.model, {
      translate: params.translate,
    });
  }

  public get _name(): string {
    return UISceneController._name;
  }

  public get isRequestInProgress(): boolean {
    return this.TranslateViewModel.statuses.isInProgress;
  }

  public get isEditing(): boolean {
    return Boolean(this.TranslateViewModel.translate.id);
  }

  public get translate(): ITranslateEntity {
    return this.TranslateViewModel.translate;
  }

  public saveTranslate = async (): Promise<void> => {
    try {
      const translate = await this.TranslateViewModel.saveTranslate();
      // @ts-ignore
      await this.displays.handleResolve({
        translate: TranslateEntity.create(translate),
      });
    } catch (error: any) {
      if (error?.status === 401) {
        this.closeScene();
      }
      message.error(
        Utils.translateIfLanguageKey(Utils.getMessageFromError(error))
      );
    }
  };

  public closeScene = (): void => {
    try {
      this.displays.handleRejects();
    } catch (error) {
      message.error(Utils.getMessageFromError(error));
    }
  };
}
